<ng-container *ngIf="!!profileStatus && !!field">
    <div class="edp-overlay-complete-profile">
        <h6 class="edp-overlay-complete-profile-title">
            {{ "pt.edp.edponline.complete.profile.title" | translate }}
        </h6>
        <div class="d-flex align-items-center">
            <edp-progress-bar [fullValue]="100" [currentValue]="profileStatus.percent"></edp-progress-bar>
            <span class="edp-overlay-complete-profile-percent">{{ profileStatus.percent }}%</span>
        </div>
        <ng-container *ngIf="!!labelDescription">
            <p class="edp-overlay-complete-profile-description">
                {{ labelDescription | translate }}
            </p>
        </ng-container>
        <button (click)="goToProfile()" class="btn btn-primary">
            {{ labelButton | translate }}
        </button>
    </div>
</ng-container>